// extracted by mini-css-extract-plugin
export default {"base":"base-G9P1W"};